import * as yup from "yup";
import i18n from "../../i18n";
import { i18_SIGNUP } from "../../i18nReferences";
import { normalizeLanguageCode } from "../../utils/languageUtils";

export const createUserSchema = () =>
    yup.object().shape({
        studioName: yup.string().trim().min(5).max(35).required(),
        billingStudioName: yup.string().min(5).max(100).required(),
        street: yup.string().max(100).required(),
        houseNo: yup.string().max(20).required(),
        zip: yup.string().max(20).required(),
        city: yup.string().max(100).required(),
        countryCode: yup.string().required(),
        subregionId: yup.string().required(),
        studioLocale: yup.string().required(),
        additionalLocales: yup
            .array()
            .of(yup.string())
            .test(
                "studio-locale-not-selected-twice",
                function (value) {
                    const { studioLocale } = this.parent;
                    if (!studioLocale || !Array.isArray(value)) {
                        return true;
                    }

                    if (value.includes(studioLocale)) {
                        return this.createError({
                            path: this.path,
                            message: { key: "YUP.ERROR.NOTONEOF" },
                        });
                    }

                    return true;
                }
            ),
        depositName: yup.string().max(30).required(),
        tattooAppointmentTypeEnabled: yup.boolean(),
        piercingAppointmentTypeEnabled: yup.boolean(),
        email: yup.string().email().max(200).required(),
        emailConfirmation: yup
            .string()
            .email()
            .max(200)
            .oneOf([yup.ref("email"), null])
            .required(),
        phone: yup.string().max(50).required(),
        kuerzel: yup.string().min(2).max(8).required(),
        termsAgreed: yup.boolean().isTrue().required(),
    }).test(
        "at-least-one-business-field",
        function (values) {
            const { tattooAppointmentTypeEnabled, piercingAppointmentTypeEnabled } = values;
            if (!tattooAppointmentTypeEnabled && !piercingAppointmentTypeEnabled) {
                return this.createError({
                    path: "tattooAppointmentTypeEnabled",
                    message: { key: "YUP.ERROR.NEED" },
                });
            }
            return true;
        }
    );

export const createNewUser = () => {
    // i18n.language keeps the browser's region (e.g. "de-DE"); the studio needs a supported language,
    // otherwise the language field looks empty and the setup on the server fails.
    const locale = normalizeLanguageCode(i18n.language || "de");
    return {
        studioName: "",
        billingStudioName: "",
        city: "",
        countryCode: "DE",
        subregionId: "",
        studioLocale: locale,
        additionalLocales: [],
        depositName: i18n.getFixedT(locale, i18_SIGNUP)("DEFAULT.DEPOSIT_NAME"),
        tattooAppointmentTypeEnabled: false,
        piercingAppointmentTypeEnabled: false,
        phone: "",
        kuerzel: "",
        email: "",
        emailConfirmation: "",
        termsAgreed: false,
    };
};

